
















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

import { Meta } from '@/decorators';
import store from '@/store';

import BackgroundImage from '@/components/ui/BackgroundImage.vue';
import RequestForm from '@/components/blocks/request/RequestForm.vue';

import IRequestMeta from '@/store/modules/request/types/IRequestMeta';
import IRequestHeader from '@/store/modules/request/types/IRequestHeader';
import IRequestForm from '@/store/modules/request/types/IRequestForm';

async function dataHook(to: Route, from: Route, next: (callback?: any) => void) {
  try {
    await store.dispatch('request/load');
    next(true);
  } catch (error) {
    store.commit('app/error', error, { root: true });
    next({ path: '/error' });
  }
}

@Component({
  components: {
    BackgroundImage,
    RequestForm,
  },
})
export default class Request extends Vue {
  private get meta(): IRequestMeta {
    return this.$store.state.request.meta;
  }

  private get header(): IRequestHeader {
    return this.$store.state.request.header;
  }

  private get form(): IRequestForm {
    return this.$store.state.request.form;
  }

  @Meta
  public metaInfo() {
    return {
      title: this.meta.title,
       meta: [{
         vmid: 'description',
         name: 'description',
         content: this.meta.description,
      }],
    };
  }

  private mounted(): void {
    this.$nextTick(() => {
      this.$bus.$emit('progress-stop');
    });
  }

  private async beforeRouteEnter(to: Route, from: Route, next: (callback?: any) => void) {
    await dataHook(to, from, next);
  }
}
